import React from 'react'

function Sortable({ children, sortKey, filterData, setFilterData, className = "", style = {}, position = "" }) {

	function changeSort() {
		var direction = 'desc'
		if (filterData?.sort?.includes(sortKey)) {
			direction = filterData.tableSortDirection === 'desc' ? 'asc' : 'desc';
		}
		setFilterData({ ...filterData, sort: `${sortKey},${direction}`, tableSortDirection: direction })
	}

	return (
		<th className={`th-sortable ${position} ${className}`} style={style} onClick={() => changeSort()}>
			{children}

			<div className="table-sort">
				{(filterData?.sort?.includes(sortKey)) ?
					<>
						{filterData.tableSortDirection === 'desc' ?
							<i className={'uil-sort-amount-down '}></i>
							:
							<i className={'uil-sort-amount-up '}></i>
						}
					</>
					:
					<i className="uil-sort"></i>
				}

				{/* <i className={'uil-sort-amount-down ' + (filterData.sort === `${sortKey},desc` && 'sort-active')}></i> */}
				{/* <i className={'uil uil-angle-up ' + (filterData.sort === `${sortKey},asc` && 'sort-active')}></i> */}
				{/* <i className={'uil uil-angle-down ' + (filterData.sort === `${sortKey},desc` && 'sort-active')}></i> */}
			</div>
		</th>
	)
}

export default Sortable